import { Box, Popper, Stack, TextField, Typography } from "@mui/material";
import { DateRangePicker } from "./index";
import { addDays, startOfWeek, endOfWeek, addWeeks, startOfMonth, endOfMonth, addMonths } from "date-fns";
import { useRef, useState } from "react";
import moment from "moment";


const MyDateRangePicker = ({ value, onChange }) => {
  const anchorRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({
    top: 0,
    left: 0,
  });

  function handleShow() {
    const bbox = anchorRef.current.getBoundingClientRect();

    const left = bbox.left + bbox.width / 2;
    const top = bbox.top + bbox.height;

    setPos({ left, top });
  }

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2} ref={anchorRef}>
        <TextField
          size="small"
          label="起始时间"
          autoComplete="off"
          value={value ? value[0] : ""}
          onFocus={() => {
            handleShow();
            setOpen(true);
          }}
        ></TextField>

        <Typography>至</Typography>

        <TextField
          size="small"
          label="终止时间"
          autoComplete="off"
          value={value ? value[1] : ""}
          onFocus={() => {
            handleShow();
            setOpen(true);
          }}
        ></TextField>
      </Stack>
      {!!open && (
        <Box
          style={{
            position: "fixed",
            zIndex: 99,
            ...pos,
          }}
        >
          <Box
            style={{
              position: "relative",
              left: "-50%",
              width: 'max-content'
            }}
          >
            <DateRangePicker
              open={open}
              toggle={() => setOpen(false)}
              onChange={(range) => {
                // console.log(range);
                onChange([moment(range.startDate).format("YYYY-MM-DD"), moment(range.endDate).format("YYYY-MM-DD")]);
                setOpen(false);
              }}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default MyDateRangePicker;
